import client from '../../base-api';

const serviceURL = '/dashboard/head-of-occupational-therapy';

const dashboardHeadOccupationalTherapyService = {

    getInfoData() {
        return client.get(`${serviceURL}`);
    },

    getUnitsDoneChart(filterData: any) {
        return client.get(`${serviceURL}/units-done-chart/${filterData?.coachingType}/${filterData?.year}/${filterData?.locationId}`);
    },
}

export default dashboardHeadOccupationalTherapyService;